// This file shared with My Account and Blog

import "@/styles/interproject.scss"
import { application } from "../helpers/stimulus"

import initNavbar from "./navbar"
import initFooter from "./footer"
import { setupTabs } from "@/components/tabs"
import { setupAccordions } from "@/components/content/Accordion"
import { setupNavbar } from "@/components/navbar"

import InterprojectNavbarController from "../controllers/navbar/interproject_navbar_controller"

initNavbar()
initFooter()
setupAccordions()
setupTabs()
setupNavbar()

application.register("interproject-navbar", InterprojectNavbarController)
